export default "__VITE_ASSET__993057c9__"